import { selector } from '@cloudio-saas/statex';
import { Platform } from 'componentregistry/platform/Platform';
import { activeItemSelector } from 'designer/activeItemSelector';
import { activeItemPathAtom } from 'designer/atoms';
import { TreeType } from 'layout/Sidebar/panels/TreeView/state';
import { itemExpandedAtom } from './atoms';
import { expandParentsAction } from './expandParentsAction';

export const itemExpandedSelector = selector<boolean, Platform>({
  path: [
    'transient',
    ':treename',
    'itemExpandedSelector',
    ':appUid',
    ':pageId',
    ':itemId',
  ],
  get: ({ get, params }, platform) => {
    const expanded = get(itemExpandedAtom, { params });
    const path = get(activeItemPathAtom, { params, props: platform });
    return expanded || path.includes(params?.itemId as string);
  },
  set: ({ call, get, set, params, props: platform }, expanded) => {
    const pageId = params?.pageId as string;
    const itemId = params?.itemId as string;
    const appUid = params?.appUid as string;
    const treename = params?.treename as TreeType;
    set(
      activeItemSelector,
      { appUid, pageId, itemId, treename, expand: false },
      { params: { appUid, treename, pageId }, props: platform },
    );

    const path = get(activeItemPathAtom, { params, props: platform });
    if (path.length) {
      // path is set when an item is selected on the page instead of the page tree
      // that way the tree will auto collapse when the user click on a different item in a different path
      // since, we got here.... user is manually trying to collapse or expand, hence clear the path
      // otherwise the active item that got clicked on the page will not be collapsible as it will be part
      // of the path the above login in the getter prevents the item from collapsed if it's in the path
      if (itemId !== 'root') {
        call(expandParentsAction, { appUid, pageId, itemId, treename });
      }
      set(activeItemPathAtom, [], { params: { appUid, pageId, treename } });
    }

    set(itemExpandedAtom, expanded, { params });
    return expanded;
  },
});
